import { render, staticRenderFns } from "./PriceLabel.vue?vue&type=template&id=904c8f74&scoped=true"
import script from "./PriceLabel.vue?vue&type=script&lang=js"
export * from "./PriceLabel.vue?vue&type=script&lang=js"
import style0 from "./PriceLabel.vue?vue&type=style&index=0&id=904c8f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904c8f74",
  null
  
)

export default component.exports